import React, { useEffect } from 'react';
import { Container, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { emailLogState } from '../../atoms/EmailLogState';
import ListHeader from '../../components/ListHeader';
import Pagination from '../../components/Pagination';
import ShowMore from '../../components/ShowMore';
import { listEmailLog } from '../../repositories/HttpRepository';
import SearchForm from './searchForm';
import useStyles from './styles';

const fields = [
  { id: 'driver_id', numeric: false, disablePadding: true, label: 'Driver ID' },
  {
    id: 'driver_name',
    numeric: false,
    disablePadding: false,
    label: 'Driver Name',
    isDisableSort: true,
  },
  {
    id: 'category',
    numeric: false,
    disablePadding: false,
    label: 'Category',
    isDisableSort: true,
  },
  {
    id: 'reason',
    numeric: false,
    disablePadding: false,
    label: 'Remark',
    isDisableSort: true,
  },
  { id: 'content', numeric: false, disablePadding: false, label: 'Content' },
  {
    id: 'created_ts',
    numeric: false,
    disablePadding: false,
    label: 'Created date',
  },
];

const EmailLogsList = () => {
  const [emailLogs, setEmailLogs] = useRecoilState(emailLogState);
  const { items, page, size, desc, order_by, total, isListing, search_text, status } = emailLogs;

  const navigate = useNavigate();
  const { classes } = useStyles();
  let { id } = useParams();

  const getList = (params) => {
    let queryParams = { size, page, search_text, status, order_by, desc };
    if (params) queryParams = { ...queryParams, ...params };
    listEmailLog(queryParams).then((resp) => {
      if (resp.ok) {
        const data = resp.data;
        setEmailLogs({
          ...emailLogs,
          items: data.items,
          page: data.page,
          size: data.size,
          total: data.total,
        });
      }
    });
  };

  useEffect(() => {
    getList();
  }, [search_text, status, order_by, desc, page]);

  const handleChangePage = (event, newPage) => {
    setEmailLogs({ ...emailLogs, page: newPage });
  };

  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;
    setEmailLogs({ ...emailLogs, desc: !isDesc, order_by: property });
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <SearchForm initValue={search_text} placeholder="Search for driver ID, driver name, category, remark ..." />
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={items.length} />
            <TableBody>
              {items &&
                items.map((item, index) => {
                  const labelId = `dsp-table-item-${index}`;
                  const regex = /(<([^>]+)>)/gi;
                  const result = item.content.replace(regex, '');
                  return (
                    <TableRow hover tabIndex={-1} key={item.id}>
                      <TableCell component="th" id={labelId} scope="row">
                        {item.driver_id}
                      </TableCell>
                      <TableCell>{item.driver_name}</TableCell>
                      <TableCell>{item.category}</TableCell>
                      <TableCell>{item.remark}</TableCell>
                      <TableCell>
                        <ShowMore text={result} length={100} />
                      </TableCell>
                      <TableCell>{moment(item.created_ts).format('DD MMM hh:mm A')}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {isListing && <LinearProgress />}
        </TableContainer>
        <Pagination total={total} size={size} onChange={handleChangePage} forceUpdatePage={page - 1} />
      </Paper>
    </Container>
  );
};
export default React.memo(EmailLogsList);
